console.log(
  '%cdancecolor.ru 📞 +7(4812)560-576',
  'font-weight: bold; color: #333; padding: 3px 5px; line-height: 1; background-color: #ffee12; border-left: 4px solid #ff1df6'
);
